import { useAtom } from 'jotai';

import { tapDataAtom } from '@/store/tap';
import { TapAtomState } from '@/types/tda';

// Este hook es utilizado para poder guardar data provicional de TORNEO DE AMIGOS POR PREMIOS
const useTapTourney = () => {
  const [tapTourneyData, setTapTourneyData] = useAtom(tapDataAtom);

  const handleSetTapTourney = (data: TapAtomState) => {
    setTapTourneyData(data);
  };

  const updateTapProperties = (updates: Partial<TapAtomState>) => {
    setTapTourneyData((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const handleResetTourney = () => {
    setTapTourneyData({});
  };

  return {
    tapTourneyData,
    handleSetTapTourney,
    handleResetTourney,
    updateTapProperties,
  };
};

export default useTapTourney;
